import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BottlerSelectionProvider } from "../../../context/BottlerSelectionContext";
import { CustomBottlerProvider } from "../../../context/CustomBottlerContext";
import { setActiveDataElement } from "../../../redux/userSlice";
import ForecastContent from "./ForecastContent";

const ManageForecast = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Bottler Concentrate Forecast"));
  }, [dispatch]);

  return (
    <BottlerSelectionProvider>
      <CustomBottlerProvider>
        <ForecastContent></ForecastContent>
      </CustomBottlerProvider>
    </BottlerSelectionProvider>
  );
};
export default ManageForecast;
